import { FC } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const USER_MANUAL_PDF_PATH = "/docs/Allsetra Portal Documentation.pdf";

const UserManual: FC = () => {
  const { t } = useTranslation();

  const handleOpenPdf = () => {
    window.open(USER_MANUAL_PDF_PATH, "_blank");
  };

  const handleDownloadPdf = () => {
    const link = document.createElement("a");
    link.href = USER_MANUAL_PDF_PATH;
    link.download = "Allsetra Portal Documentation.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: 4
      }}
    >
      <Paper
        elevation={2}
        sx={{
          padding: 4,
          textAlign: "center",
          maxWidth: 500,
          width: "100%"
        }}
      >
        <Typography variant="h5" gutterBottom>
          {t("userManualPage.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t("userManualPage.description")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap"
          }}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<OpenInNewIcon />}
            onClick={handleOpenPdf}
            sx={{
              color: "#FFF"
            }}
          >
            {t("buttonsText.openManual", { defaultValue: "Open manual" })}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={handleDownloadPdf}
          >
            {t("buttonsText.download", { defaultValue: "Download" })}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserManual;
